import { render, staticRenderFns } from "./InventoryDetailSkeleton.vue?vue&type=template&id=0caed41f&scoped=true"
import script from "./InventoryDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./InventoryDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InventoryDetailSkeleton.vue?vue&type=style&index=0&id=0caed41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caed41f",
  null
  
)

export default component.exports